import { Injectable } from '@angular/core';
import {HttpClient, HttpHeaders} from "@angular/common/http";
import {Observable} from "rxjs";
import {BackendService} from "./backend.service";
import {map} from "rxjs/operators";
import {ResponseDto} from "../dto/response.dto";

@Injectable({
  providedIn: 'root'
})
export class UserService {

  constructor(private backend: BackendService) {}
  urlPrefix = 'api/account';

  /**
   * Método para registrar la cuenta
   * @param accountData
   */
  createUser(accountData: any): Observable<any> {
    return this.backend.post(this.urlPrefix, accountData).pipe(
        map(response => response.response)
    );
  }

  /**
   * Método para validar los datos de la cuenta
   * @param accountData --> Datos de la cuenta
   */
  accountDataValidation(accountData: any): Observable<any> {
    const url = this.urlPrefix + '/initial/validation';
    return this.backend.post(url, accountData).pipe(
        map(response => response.response)
    );
  }
    getUserInfo(): Observable<any> {
        const url = `${this.urlPrefix}/data`;
        return this.backend.get(url).pipe(
            map((response: ResponseDto) => response.response)
        );
    }
}
